// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__Hpl11","tab":"ProcedureTabs_tab__2CXqb"};